<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
            :ref="'manualCrud'"
            crudName="Manuais"
            newText="Novo Manual"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :extra="extra"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :enableReset="false"
            :dataForm="dataForm"
            @view-manual="onViewManual"
            @view-sync="onViewSync"
        >
        </base-crud>
        <manual-sync-view ref="manualSyncView"/>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import ManualSyncView from './ViewSync';

export default {
  data() {
    return {
      table: "manualTable",
      columns: ["id", "titulo", "descricao", "status", "actions"],
      tableData: ["id", "titulo", "descricao", "status"],
      extra: [
        {
          id: 'view-manual',
          name: 'view-manual',
          title: 'Visualizar',
          class: 'btn btn-sm btn-info btn-view-manual',
          icon: 'fas fa-eye',
          label: ''
        },
        {
          id: 'view-sync',
          name: 'view-sync',
          title: 'Ver Sincronização',
          class: 'btn btn-sm btn-primary btn-sync-view',
          icon: 'fas fa-sync',
          label: ''
        }
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "titulo", "descricao", "status"],
        pagination: {chunk: 10, dropdown: false, nav: "scroll"},
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          titulo: "Título",
          descricao: "Descrição",
          status: "Status",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {id: 1, text: "Ativo"},
            {id: 0, text: "Inativo"},
          ],
        },
        templates: {
          status: function (h, row) {
            const isActive = row.status === true || row.status === 1 || row.status === "true";
            return h('span', {class: isActive ? 'badge badge-success' : 'badge badge-secondary'}, isActive ? 'Ativo' : 'Inativo');
          },
        },
        requestFunction(data) {
          const query = this.$parent.$parent.$parent.query(data.query);
          const requestData = {params: {...data, query: ""}};
          return this.$http.get(`${this.url}?orderByDesc=id&${query}`, requestData).catch(e => this.dispatch("error", e));
        },
      },
      endPoint: "manuais/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
    ManualSyncView,
  },
  methods: {
    query(query) {
      const columns = {
        id: "id",
        titulo: "titulo",
        descricao: "descricao",
        status: "status",
      };

      let filters = "";
      $.each(query, (index, value) => {
        if (columns[index]) filters += `${columns[index]}=${value}&`;
      });
      return filters;
    },

    onViewManual(payload) {
      const id = payload.row.id;
      this.$router.push({path: `/manuais/view/${id}`});
    },

    onViewSync(payload) {
      const id = payload.row.id;
      if (this.$refs.manualSyncView && this.$refs.manualSyncView.open) {
        this.$refs.manualSyncView.open(id);
      }
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>

<style>
.btn-sync-view, .btn-view-manual {
  min-width: 25px !important;
  max-width: 25px !important;
  width: 25px !important;
  min-height: 25px !important;
  max-height: 25px !important;
  height: 25px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 11px !important;
  line-height: 1 !important;
  border-radius: 4px !important;
}

.btn-sync-view i, .btn-view-manual i {
  margin: 0 !important;
}
</style>
